// extracted by mini-css-extract-plugin
module.exports = {"overviewCustomer":"styles_overviewCustomer__1qadL"};